module.exports = __webpack_public_path__ + "static/media/dish_card2.f6c427fc.png";